import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type ChangeCardNewNameRequest } from '@shared/api';

interface ManageCardNameType {
  loading: boolean;
  error: string | null;
  success: boolean;
  create: (request: ChangeCardNewNameRequest, id: string, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useManageCardNameStore = create<ManageCardNameType>((set) => ({
  loading: false,
  error: null,
  success: false,

  create: ApiUtils.wrapperApi(async (request, id, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.changeNameCard(request, id, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, error: null, success: false }),
}));
